<ngx-loading [show]="loading" id="gridDisableDiv"></ngx-loading>

<div class="d-flex flex-column h-100 px-4 py-3">
  <div class="form-types d-flex">
    <div class="form-types d-flex" style="position: relative">
      <ngx-loading [show]="disableTabsAndGrid" id="gridDisableDiv"></ngx-loading>
      <button
        *ngFor="let formTypeName of formTypeNames | keyvalue"
        class="btn btn--tab text-uppercase em-btn-nav-tab mr-2"
        [class.selected]="selectedFormType === formTypeName.key"
        (click)="onSelectTab(formTypeName.key)"
      >
        {{ formTypeName.value }}
      </button>
    </div>
    <div *ngIf="!editMode" class="d-flex ml-auto">
      <button type="button" class="btn em-btn em-btn-green mb-1 mr-1" (click)="addHandler()">
        <i class="fal fa-plus-circle"></i>&nbsp;Create eForm
      </button>
      <button type="button" class="btn em-btn em-btn-green mb-1" (click)="addFromTemplateHandler()">
        <i class="fal fa-cloud"></i>&nbsp;Add From Library
      </button>
    </div>
    <div *ngIf="editMode" class="d-flex ml-auto">
      <button type="button" class="btn em-btn em-btn-green flex-nowrap mr-1 mb-1" (click)="saveHandler()">
        <i class="fal fa-save"></i>
        &nbsp;Save
      </button>
      <button type="button" class="btn em-btn em-btn-green flex-nowrap mr-1 mb-1" (click)="cancelHandler()">
        <i class="fal fa-ban"></i>
        &nbsp;Cancel
      </button>
    </div>
  </div>
  <div class="header-line"></div>
  <div class="row mt-2 minh-0 flex-grow-1">
    <div class="h-100 col-3">
      <ngx-loading [show]="disableTabsAndGrid" id="gridDisableDiv"></ngx-loading>
      <kendo-grid
        [data]="gridView"
        [pageSize]="gridState.take"
        [skip]="gridState.skip"
        [sort]="gridState.sort"
        [sortable]="true"
        [selectable]="true"
        [style.height.%]="100"
        (edit)="editHandler($event)"
        (remove)="deactivateHandler($event)"
        (selectionChange)="onSelectRow($event)"
        kendoGridSelectBy="id"
        [selectedKeys]="selectedKeys"
        [rowClass]="rowCallback"
      >
        <kendo-grid-column
          field="name"
          title="Name"
          [headerClass]="'teal-background white-font'"
          [class]="{ nameColumn: true }"
        >
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <div class="d-flex">
              <span>{{ dataItem.name }}</span>
              <div *ngIf="dataItem.isSharedForm" class="ml-auto">
                <i class="far fa-cloud" title="Shared Form"></i>
              </div>
            </div>
            <div *ngIf="dataItem.notes && dataItem.notes !== ''">
              <span> (<strong>Notes:</strong> {{ dataItem.notes }}) </span>
            </div>
          </ng-template>
        </kendo-grid-column>
        <ng-template kendoGridDetailTemplate let-dataItem>
          <section>
            <div>
              <strong>Service:</strong>
              {{ dataItem.serviceTemplateType ? dataItem.serviceTemplateType.name : 'None' }}
            </div>
            <div><strong>Created Date:</strong> {{ dataItem.createdDate | date : 'yyyy-MM-dd' }}</div>
            <div>
              <strong>Created by User:</strong>
              {{
                dataItem.createdByUser
                  ? dataItem.createdByUser.firstName + ' ' + dataItem.createdByUser.lastName
                  : 'Anonymous'
              }}
            </div>
            <div *ngIf="dataItem.isSharedForm">
              <div>
                <strong>Shared by User:</strong>
                {{
                  dataItem.sharedByUser
                    ? dataItem.sharedByUser.firstName + ' ' + dataItem.sharedByUser.lastName
                    : 'Anonymous'
                }}
              </div>
              <div>
                <strong>Shared by Clinic:</strong>
                {{ dataItem.sharedByClinic ? dataItem.sharedByClinic.name : 'Anonymous' }}
              </div>

              <div><strong>Shared Date:</strong> {{ dataItem.sharedFormCreationDate | date : 'yyyy-MM-dd' }}</div>
            </div>
          </section>
        </ng-template>
        <kendo-grid-command-column
          title="Actions"
          min-width="115px"
          [width]="115"
          [headerClass]="'teal-background white-font'"
        >
          <ng-template kendoGridCellTemplate let-dataItem="dataItem">
            <div *ngIf="!dataItem.isDeleted">
              <button kendoGridEditCommand class="btn kendo-btn" kendoTooltip title="Edit Form Details">
                <i class="fas fa-pencil"></i>
              </button>
              <button
                class="btn kendo-btn k-button"
                (click)="editFormHandler(dataItem, $event)"
                kendoTooltip
                tooltipClass="em-tooltip"
                position="top"
                title="Edit Form"
              >
                <i class="far fa-edit"></i>
              </button>
              <button
                class="btn kendo-btn k-button"
                (click)="cloneFormHandler(dataItem.id)"
                kendoTooltip
                title="Clone Form"
              >
                <i class="fal fa-copy"></i>
              </button>
              <button kendoGridRemoveCommand class="btn kendo-btn" kendoTooltip title="Deactivate Form">
                <i class="fas fa-minus-circle"></i>
              </button>
            </div>
            <div *ngIf="dataItem.isDeleted" class="center">
              <label class="switch align-text-top" kendoTooltip title="Activate Form"
                ><input #activateFormCheckbox type="checkbox" (click)="activateFormHandler(dataItem)" /><span
                  class="slider round"
                ></span
              ></label>
            </div>
          </ng-template>
        </kendo-grid-command-column>
      </kendo-grid>
    </div>
    <div class="h-100 col-9 light-grey-background">
      <ng-container *ngIf="selectedDataItem">
        <ng-scrollbar class="h-100">
          <app-form-builder
            *ngIf="editMode"
            [form]="editingDataItem"
            [refreshBuilder]="formRefreshed$"
          ></app-form-builder>
          <div *ngIf="!editMode" class="card card-outer">
            <div class="card-body">
              <div class="d-flex justify-content-end">
                <button
                  kendoTooltip
                  title="Share this form with other clinics in Emily"
                  type="button"
                  class="btn em-btn em-btn-green flex-nowrap mb-3"
                  (click)="shareFormHandler(selectedDataItem)"
                >
                  <i class="fas fa-share-alt"></i>&nbsp;Share in Library
                </button>
              </div>
              <div class="card bg-light">
                <app-form-viewer
                  [form]="selectedDataItem"
                  [editable]="false"
                  [refreshViewer]="formRefreshed$"
                ></app-form-viewer>
              </div>
            </div>
          </div>
        </ng-scrollbar>
      </ng-container>
      <ng-container *ngIf="!selectedDataItem">
        <div class="h-100 w-100 d-flex align-items-start justify-content-center px-0">
          <span class="m-auto font-weight-bold" style="font-size: 2em">Please select a form.</span>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<app-actionpanel></app-actionpanel>
